import React, { forwardRef, useEffect, useMemo, useRef, useState } from "react";
import Label from "../../ui/Label";
import DateInput from "../../ui/DateInput";
import TimeInput from "../../ui/TimeInput";
import { ROUTES } from "../../utils/Routes";
import { useTabs } from "../../hooks/useTabs";
import Space from "../../ui/Space";
import { KBD } from "../../utils/Keybindings";
import { listen } from "../../hooks/Listener";
import dayjs from "dayjs";
import Float from "../../ui/Float";
import Button from "../../ui/Button";
import { kbdEvent } from "../../utils/Utils";

const SalesIn = forwardRef(function ReportFilter(props, ref) {

    const { controller = "", escape = () => { }, onUpdate = () => { }, onSave = () => { }, report = {}, height = 260, goto = () => { }, setReport = () => { }, where_type = "AND", edit = false, show_add = false, small = false, headerClass = "", showColumnHeaders = true, header = "",
        value = {},
        onFocus = () => { },
        onBlur = () => { },
        onFilled = () => { }
    } = props;


    const beforeEscape = () => {

        update({
            date_from : _date_from,
            date_to : _date_to,
            date_from_time : _date_from_time,
            date_to_time : _date_to_time
        })

        setSaved(false);

        escape(tabs);
    }



    const saveFilter = () => {
        if (refs?.current[index]) refs.current[index].blur();
        let _f = { ...value };
        let _from = getVal("date_from");
        let _to = getVal("date_to");
        if (_from) {
            _f.value_1 = _from.split(" ")[0] + " " + getVal("date_from_time") + ":00";
        }

        if (_to) {
            _f.value_2 = _to.split(" ")[0] + " " + getVal("date_to_time") + ":00";
        }
        onSave(_f);
        setIndex("")
        setSaved(false)
    }


    const route = ROUTES.REPORTS.FILTER_SALES_IN;
    const sales_period_between = value;
    const _date_from = (sales_period_between?.value_1) ? sales_period_between?.value_1 : dayjs().add(-1, "day").format("YYYY-MM-DD");
    const _date_from_time = (sales_period_between?.value_1 && sales_period_between?.value_1.includes(" ")) ? dayjs(sales_period_between?.value_1).format("HH:mm") : "00:00";
    const _date_to = (sales_period_between?.value_2) ? sales_period_between?.value_2 : dayjs().format("YYYY-MM-DD");
    const _date_to_time = (sales_period_between?.value_2 && sales_period_between?.value_2.includes(" ")) ? dayjs(sales_period_between?.value_2).format("HH:mm") : "23:59";

    const defaultTabs = useMemo(() => [
        { set: "scope", label: "date_from", key: "date_from", value: _date_from },
        { set: "scope", label: "date_from_time", key: "date_from_time", value: _date_from_time },
        { set: "scope", label: "date_to", key: "date_to", value: _date_to },
        { set: "scope", label: "date_to_time", key: "date_to_time", value: _date_to_time },
        { set: "scope", label: "cycle", key: "cycle", value: "", skip: true },
    ], [_date_from, _date_from_time, _date_to, _date_to_time]);




    const [saved, setSaved] = useState(false);

    const runUpdate = () => {
        if (refs?.current[index]) refs.current[index].blur();
        let _f = { ...value };
        let _from = getVal("date_from");
        let _to = getVal("date_to");
        if (_from) {
            _f.value_1 = _from.split(" ")[0] + " " + getVal("date_from_time") + ":00";
        }

        if (_to) {
            _f.value_2 = _to.split(" ")[0] + " " + getVal("date_to_time") + ":00";
        }

        setSaved(false);
        onUpdate(_f);
    }

    const {
        tabs, setTabs, index, setIndex, update, getVal, editProps, next, prev, refs
    } = useTabs(defaultTabs, "");

    const prevValueRef = useRef(value);

    useEffect(() => {
        const prev = prevValueRef.current;

        if (
            prev?.value_1 !== value?.value_1 ||
            prev?.value_2 !== value?.value_2
        ) {
            setTabs(defaultTabs);
        }

        prevValueRef.current = value;
    }, [value, defaultTabs]);

    useEffect(() => {
        if (edit) {
            window.bm_state.value = route;
            setIndex("date_from")
        } else {
            if (index !== "") {
                setIndex("")
            }
        }
    }, [edit])

    useEffect(() => {
        if (refs?.current[index]) refs.current[index].focus();

    }, [index, edit]);

    useEffect(() => {

        const actions = [
            {
                key: KBD.ESCAPE, action: () => {
                    if (refs?.current[index]) refs.current[index].blur();
                    setIndex("")
                    setTimeout(() => {
                        beforeEscape(tabs)
                    }, 10)

                }
            },
            { key: KBD.SHIFT_TAB, action: () => { if (index === "date_from") { runUpdate(); goto("scope_type") } else { next(); } } },
            { key: KBD.TAB, action: () => { if (index === "date_to_time") { runUpdate(); goto("sales_types") } else { next(); } } },
            { key: KBD.ENTER, action: () => { if (index === "date_to_time") { runUpdate(); goto("sales_types") } else { next(); } } },
            { key: KBD.ARROW_DOWN, action: () => { if (index === "date_to_time") { runUpdate(); goto("sales_types") } else { next(); } } },
            { key: KBD.ARROW_UP, action: () => { if (index === "date_from") { runUpdate(); goto("scope_type") } else { prev(); } } },
            { key: KBD.PAGE_DOWN, action: () => saveFilter() },
        ];
        return listen(controller, route, actions, () => { }, [
            KBD.TAB,
            KBD.SHIFT_TAB,
            KBD.ENTER,
            KBD.PAGE_DOWN,
            KBD.ARROW_DOWN,
            KBD.ARROW_UP,
            KBD.ESCAPE
        ]);
    }, [index, tabs, props.autoSave]);


    const updateFromTo = () => {
        setIndex("date_to");
        setTimeout(() => {
            update({
                date_from_time: getVal("date_to_time"),
                date_from: getVal("date_to")
            })
        }, 10);
    }

    const cycle = () => {
        setIndex("cycle")

        setTimeout(() => {
            const dateTo = getVal("date_to");
            const timeTo = getVal("date_to_time");
            // remember
            if (!saved) {
                setSaved(
                    {
                        date_to: _date_to,
                        date_to_time: _date_to_time,
                        date_from: _date_from,
                        date_from_time: _date_from_time,
                    }
                )
            }
            // set
            update("date_from", dateTo);
            update("date_from_time", timeTo);
            const now = dayjs();
            update("date_to", now.format("YYYY-MM-DD"));
            update("date_to_time", now.format("HH:mm"));
        }, 20)

    };

    const revert = () => {
        if (!saved) return;
        setIndex("cycle")
        setTimeout(() => {
            const o = { ...saved };
            update("date_to", o.date_to);
            update("date_to_time", o.date_to_time);
            update("date_from", o.date_from);
            update("date_from_time", o.date_from_time);
            setSaved(false)
        }, 20)
    };


    return (
        <div className="no-focus" onBlur={() => onBlur()} onFocus={() => onFocus()} onClick={() => onFocus()} ref={ref} tabIndex={0}>
            <Space style={{ "alignItems": "start" }}>
      
                <div>
                    <Label >From</Label>
                    <br />
                    <Label>To</Label>
                </div>
                <Space style={{ "alignItems": "start" }}>
                    <div>
                        <DateInput pageupcycle={false} show_preset={true} cycle={["to time"]} onCycle={(e) => updateFromTo()} route={route} shrink={false} width={95} {...editProps("date_from")} onClick={() => (index !== "date_from") && setIndex("date_from")} onPageUp={() => updateFromTo()} onFilled={() => setIndex("date_from_time")} onBlur={(e) => { update("date_from", e) }} edit={edit} />
                        <div className="shim" /><div className="shim" /><div className="shim" />
                        <DateInput show_preset={true} cycle={["today", "yesterday"]} route={route} shrink={false} width={95} {...editProps("date_to")} onClick={() => (index !== "date_to") && setIndex("date_to")} onFilled={() => setIndex("date_to_time")} onBlur={(e) => { update("date_to", e) }} edit={edit} />
                    </div>

                    <div>
                        <TimeInput show_preset={true} route={route} shrink={false} width={95} {...editProps("date_from_time")} onEnter={() => next()} onClick={() => (index !== "date_from_time") && setIndex("date_from_time")} onFilled={() => setIndex("date_to")} edit={edit} />
                        <div className="shim" /><div className="shim" /><div className="shim" />
                        <Float>
                            <TimeInput show_preset={true} cycle={["23:59", "00:00", "now"]} route={route} shrink={false} width={95} {...editProps("date_to_time")} onClick={() => (index !== "date_to_time") && setIndex("date_to_time")} onFilled={() => setTimeout(() => {kbdEvent(KBD.ARROW_DOWN)}, 50 )} edit={edit} />
                            <div style={{ "position": "absolute", "marginLeft": "120px" }}><Button className="ui-button small" {...editProps("cycle")}><strong onClick={() => (saved) ? revert() : cycle()} style={{ "fontSize": "14px" }}><small>{(saved) ? "Revert" : "Update to now"}</small></strong></Button></div>
                        </Float>


                    </div>

                </Space>

            </Space>

        </div>
    )
});

export default SalesIn;